export default __webpack_public_path__ + "static/media/Administrator.9ed51380.png";